module.exports = {
    bindings: {
        active: '@'
    },
    templateUrl: 'case-law/components/case-law-subnav.html'
};